import React from "react"
import PropTypes from "prop-types"

import NotificationItem from './NotificationItem'
import BadgeAlert from '../gamification_components/BadgeAlert'
import LexicoinAlert from '../gamification_components/LexicoinAlert'

class NotificationSection extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      notifications: [],
      points_notification: [],
      badge_notification: []
    }

    this.renderAlerts = this.renderAlerts.bind(this)
    this.renderNotifications = this.renderNotifications.bind(this)
    this.deleteNotification = this.deleteNotification.bind(this)
    this.deleteBadgeNotification = this.deleteBadgeNotification.bind(this)
    this.getNotifications = this.getNotifications.bind(this)
  }

  componentDidMount() {
    this.getNotifications()
  }

  deleteNotification(id) {

    const data = {
      id: id
    }
    $.ajax({
      url: `../delete_notification`,
      dataType: 'JSON',
      type: 'DELETE',
      data: data,
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
          this.setState({
            notifications: data.data.notifications,
            points_notification: data.data.points_notification,
            badge_notification: JSON.parse(data.data.badge_notification)
          })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  getNotifications() {
    $.ajax({
      url: `../get_user_notifications`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
          this.setState({
            notifications: data.data.notifications,
            points_notification: data.data.points_notification,
            badge_notification: JSON.parse(data.data.badge_notification)
          })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  deleteBadgeNotification(id) {
    const data = {
      id: id
    }
    $.ajax({
      url: `../onboard_badge`,
      dataType: 'JSON',
      type: 'POST',
      data: data,
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.getNotifications()
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  renderAlerts() {
    if(this.state.points_notification.length > 0) {
      return (<LexicoinAlert points={this.state.points_notification[0]} confettiLottie={this.props.confettiLottie} deleteNotification={this.deleteNotification} lexicoin={this.props.lexicoin}/>)
    } else if(this.state.badge_notification.length > 0) {
      return (<BadgeAlert badge={this.state.badge_notification[0]} confettiLottie={this.props.confettiLottie} deleteBadgeNotification={this.deleteBadgeNotification}/>)
    }
    return null
  }

  renderNotifications() {
    if(this.state.notifications.length > 0) {
      return this.state.notifications.map((not, i) => {
        return  (
          <NotificationItem
            notification={not}
            key={i}
            closeIcon={this.props.closeIcon}
            onClick={this.deleteNotification}
          />
        )
      })
    }
    return (
        <div className="form_standard">
          <div className="wrapper_input">
              <h5 className="greyText" style={{marginBottom:20}}>All caught up!</h5>
          </div>
        </div>
    )
  }

  render() {
    return(
      <div className="matches_wrapper padding_page">
      <h4 className="sectionHeader" style={{textAlign: 'left'}}>Notifications</h4>
      {this.renderAlerts()}
        <div className="match-profile-container">
          <div className="wrapper_how_to_lex profile_heading">
                  <div className="user-notifications">
                      {this.renderNotifications()}
                  </div>
            </div>
          </div>
        </div>

    )
  }

}

export default NotificationSection;

// // <%# if  @id_verification != nil && (@id_verification.nationality_verified === false || @id_verification.given_name_verified === false || @id_verification.last_name_verified === false || @id_verification.dob_verified === false) %>
// //     <%#= link_to verify_identity_status_path do %>
//         <div class="wrapper_form_dark form_section" style="margin-top:1rem; border: #01579b 2px solid">
//           <p class="heading_standard red" style="text-align:center;">There's an issue with your Identity Verification. Click here to resolve.</p>
//         </div>
//     // <%# end %>
// // <%# elsif  @id_verification != nil && (@id_verification.nationality_verified === nil || @id_verification.given_name_verified === nil || @id_verification.last_name_verified === nil || @id_verification.dob_verified === nil) %>
//     // <%#= link_to verify_identity_steps_path do %>
//         <div class="wrapper_form_dark form_section" style="margin-top:1rem; border: #01579b 2px solid" >
//           <p class="heading_standard" style="text-align:center;">You have not completed your Identity Verification. Click here to complete!</p>
//         </div>
// //     <%# end %>
// // <%# elsif @id_verification != nil && @id_verification.avatar_approved === false %>
// //     <%#= link_to verify_identity_status_path do %>
//         <div class="wrapper_form_dark form_section" style="margin-top:1rem; border: #01579b 2px solid">
//           <p class="heading_standard red" style="text-align:center;">There's an issue with your profile photo. Click here to resolve.</p>
//         </div>
// //     <%# end %>
// //
// // <%# elsif @user_notifications.length === 0 && @notifications.length === 0 %>
//
// // <%# elsif user_signed_in? && current_user.status === "Travelling" %>
//   <div class="wrapper_form_dark form_section" style="margin-top:1rem;">
//     // <p class="red heading_standard" style="text-align:center;"><%#= t 'notification.travel_mode'%></p>
//   </div>
